export default __webpack_public_path__ + "static/media/lag.5d29b759.svg";